// src/redux/api/pdfTemplateFieldsApi.ts

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios, { AxiosError } from "axios";
import { BASE_SHARED_SECURE_ROUTE } from "src/constants/api";

export const PDFTemplatesApi = createApi({
    reducerPath: "lobbie/admin/pdfTemplateFields",
    baseQuery: fetchBaseQuery({}),
    endpoints: (builder) => ({
        getPdfTemplateFields: builder.query<string[] | undefined, number>({
            /**
             * URL it hits:
             *   {BASE_SHARED_SECURE_ROUTE}/admin/pdf_templates/pdf_template_fields?formTemplatePDFId={id}
             */
            async queryFn(formTemplatePDFId) {
                const url = `${BASE_SHARED_SECURE_ROUTE}/admin/pdf_templates/pdf_template_fields`;
                try {
                    const response = await axios.get<string[]>(url, {
                        params: { formTemplatePDFId },
                        withCredentials: true,
                    });
                    return { data: response.data };
                } catch (err) {
                    const error = err as AxiosError;
                    return {
                        error: {
                            status: error.response?.status ?? 500,
                            data: error.response?.data ?? error.message,
                        },
                    };
                }
            },
        }),
    }),
});

export const { useGetPdfTemplateFieldsQuery, useLazyGetPdfTemplateFieldsQuery } = PDFTemplatesApi;

export default PDFTemplatesApi;
